import getProfileItems from "./getProfileItems";
import InvestmentInvestor from "../InvestmentInvestor";
import type { Account, Investment, DescriptionItem } from "../../../types";

const LABEL_INVESTOR = "Investor";

type Options = {
  account: Account;
  investment: Investment;
  openAccountDrawer: () => void;
  onAfterAccountUpdate: () => void;
  openInvestmentProfileUpdateDrawer: () => void;
  openInvestmentAccreditationUpdateModal: () => void;
};

const getItems = ({
  account,
  investment,
  openAccountDrawer,
  onAfterAccountUpdate,
  openInvestmentProfileUpdateDrawer,
  openInvestmentAccreditationUpdateModal,
}: Options): DescriptionItem[] => {
  const {
    investor,
    isFunded,
    isSigned,
    investorErrors = [],
  } = investment;

  const profileItems = getProfileItems(investment, openInvestmentProfileUpdateDrawer);

  const items: DescriptionItem[] = [
    {
      label: LABEL_INVESTOR,
      value: (
        <InvestmentInvestor
          errors={investorErrors}
          account={account}
          onClick={openAccountDrawer}
          investor={investor}
          isFunded={isFunded}
          isSigned={isSigned}
          onAfterAccountUpdate={onAfterAccountUpdate}
          openInvestmentAccreditationUpdateModal={openInvestmentAccreditationUpdateModal}
        />
      ),
    },
    ...profileItems,
  ];

  return items;
};

export default getItems;
